import EventEmitter from "@protobufjs/eventemitter";

const sleep = async seconds =>
  new Promise(resolve => {
    setTimeout(resolve, seconds);
  });

const createQueue = () => {
  let _nonce = 0;
  let _idle = true;
  let _tasks = [];
  const qEvent = new EventEmitter();

  const execute = async () => {
    if (!_tasks.length) return (_idle = true);
    _idle = false;
    const { taskId, taskFn } = _tasks.shift();
    try {
      const data = await taskFn();
      qEvent.emit(taskId, null, data);
    } catch (error) {
      qEvent.emit(taskId, error);
    }
    execute();
  };

  return {
    async push(taskFn) {
      _nonce++;
      const taskId = _nonce;
      _tasks.push({ taskId, taskFn });
      if (_idle) {
        execute();
      }
      return new Promise((resolve, reject) => {
        qEvent.on(taskId, (err, data) => {
          qEvent.off(taskId);
          if (err) return reject(err);
          resolve(data);
        });
      });
    },
    clear() {
      _nonce = 0;
      _tasks = [];
    }
  };
};

export default {
  sleep,
  createQueue
};
